import { Input, InputGroup, InputRightAddon } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { InputFieldInterface } from '@/model/profile.mjs';
import { BUSINESS_NAME } from '@/utils/constants';

export const InputField = ({
  detail,
  name,
  setProfileData,
  profileData,
  register,
  isLicenseValidated
}: InputFieldInterface) => {
  const [value, setValue] = useState<string | null>(detail);
  useEffect(() => {
    setProfileData({ ...profileData, [name]: value });
  }, [value]);
  function placeholder() {
    if (name === 'name') return BUSINESS_NAME;
    else if (name === 'store_premise_street') return 'Street';
    else if (name === 'store_premise_city') return 'City';
    else if (name === 'store_premise_state') return 'State';
    else if (name === 'store_premise_zip_code') return 'Zip Code';
    else if (name === 'contact_phone') return 'Phone Number';
    else if (name === 'store_contact_fax') return 'Fax';
    else if (name === 'contact_email') return 'Email';
    else if (name === 'store_id') return 'Enter store domain';
    else if (name === 'seller_email') return 'Email';
    else return '1-54-012-01-1H-12345';
  }
  function disabledInput() {
    if (isLicenseValidated !== undefined)
      return { disabled: !isLicenseValidated };
  }

  return (
    <>
      <InputGroup className="inputType">
        <Input
          {...disabledInput()}
          placeholder={placeholder()}
          {...register(name, {
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
              setValue(e.target.value);
              if (e.target.value === '') setValue(null);
            }
          })}
        />
        {name === 'seller_email' && (
          <InputRightAddon fontSize={'12px'} padding={'8px'} children="@masterffl.com" />
        )}
      </InputGroup>
    </>
  );
};
